import { useLayoutEffect } from "react"
import useForceUpdate from "../use-force-update"

export default function useRerenderOnce() {
  const forceUpdate = useForceUpdate()

  useLayoutEffect(forceUpdate, [])
}
